import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Props } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
import Form from '@websky/core/src/Checkout/components/Checkout/FormBlockSlot/FormBlockSlot';
import { FormValues, PassengerValues } from '@websky/core/src/Checkout/types';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import { useSetSsrDataMutation, InputSsrInfo } from '@websky/graphql';

const CheckoutForm: React.FC<Props> = ({ onFormSubmit, ...props }) => {
	const order = useSelector(getOrder);

	const [setSsrData] = useSetSsrDataMutation();

	const onFormSubmitHandler = useCallback(
		async (values: object) => {
			try {
				const passengersWithoutSsr: PassengerValues[] = [];
				const ssrs: InputSsrInfo[][] = [];

				(values as FormValues).passengers.forEach(
					({ organizationName, personnelNumber, ...props }, passengerId) => {
						if (organizationName || personnelNumber) {
							const ssrValue: InputSsrInfo = {
								code: 'OTHS',
								statusCode: null,
								travellerIds: [passengerId.toString()],
								segmentIds: order.flight.segments.map(segment => segment.segment.id)
							};

							ssrs.push([
								{
									...ssrValue,
									description: organizationName
								},
								{
									...ssrValue,
									description: personnelNumber
								}
							]);
						}

						passengersWithoutSsr.push(props);
					}
				);

				const result = await onFormSubmit({
					...values,
					passengers: passengersWithoutSsr
				});

				if (result) {
					const orderSsrs: InputSsrInfo[] =
						result.ssrData?.map(ssr => ({
							id: ssr.id,
							code: ssr.ssrCode,
							statusCode: ssr.status,
							travellerIds: ssr.travellerIds,
							segmentIds: ssr.segmentIds,
							description: ssr.ssrText
						})) || [];

					if (ssrs.length) {
						const unionSsrs = [...orderSsrs, ...ssrs.reduce((arr, ssr) => [...arr, ...ssr], [])];
						await setSsrData({
							variables: {
								parameters: {
									orderId: order.id,
									ssrs: unionSsrs
								}
							}
						});
					}
				}

				return result;
			} catch (e) {
				console.log(e);

				return null;
			}
		},
		[order, props.orderSubsidyState?.travellers]
	);

	return <Form {...props} onFormSubmit={onFormSubmitHandler} />;
};

export default CheckoutForm;
